exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".clickable[data-v-23e86914]{cursor:pointer}\n", ""]);

